interface IChannelManagerTypes {
  noCollaboration: string;
  tlLincoln: string;
  temairazu: string;
  neppan: string;
  raku2: string;
}

export const ChannelManagerTypes: IChannelManagerTypes = {
  noCollaboration: "no_collaboration",
  tlLincoln: "tl_lincoln",
  temairazu: "temairazu",
  neppan: "neppan",
  raku2: "raku2",
};
